export default "__VITE_ASSET__BH7u8iAn__"